/** @flow */
export default from './ScrollSync'
export ScrollSync from './ScrollSync'



// WEBPACK FOOTER //
// ./source/ScrollSync/index.js